<template>
  <div>
    <!-- 搜索 -->
    <div class="container">
      <ESearch
        :data="searchData"
        :field-list="fieldList"
        :list-type-info="listTypeInfo"
        @handleFilter="handleFilter"
        @handleReset="handleReset"
      ></ESearch>
    </div>
    <div class="container">
      <!-- 创建方式 -->
      <div class="handle-wrapper">
        <eui-btn font-size="12px" type="secondary" @click="handleAdd('ADD')"
          >新增</eui-btn
        >
        <eui-btn
          :disabled="tableSelectData.length === 0"
          type="secondary"
          font-size="12px"
          @click="batchDel('mutil', null)"
        >
          删除
        </eui-btn>
      </div>
      <!-- table -->
      <ETableList
        ref="multipleTable"
        :row-key="'purchaseDemandItemId'"
        :table-data="tableData"
        :table-label="tableLabel"
        :selection-show="true"
        :check-selectable="checkSelectable"
        @handleSelectionChange="handleSelectionChange"
      >
        <template #categoryName="slot">
          <span>{{ slot.scope.$index + 1 }}</span>
        </template>
        <template #operation="slot">
          <eui-btn
            type="link"
            font-size="12px"
            @click="goToDetail(slot.scope.row.creditEvaluationId)"
            >查看</eui-btn
          >
          <eui-btn
            v-if="slot.scope.row.status !== 2"
            type="link"
            font-size="12px"
            @click="handleAdd('EDIT', slot.scope.row.creditEvaluationId)"
            >修改</eui-btn
          >
          <eui-btn
            v-if="slot.scope.row.status !== 2"
            type="link"
            font-size="12px"
            @click="batchDel('single', slot.scope.row.creditEvaluationId)"
            >删除</eui-btn
          >
        </template>
      </ETableList>
      <!-- 分页 -->
      <div class="pagination">
        <el-pagination
          style="margin-top: 20px"
          :pager-count="5"
          :page-sizes="[10, 20, 30]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="queryData.pageNum"
          :total="pageTotal"
          :page-size.sync="queryData.pageSize"
          prev-text="上一页"
          next-text="下一页"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </div>
    <el-drawer
      title="新增"
      :visible.sync="drawerVisible"
      append-to-body
      direction="rtl"
      size="840px"
      :destroy-on-close="true"
    >
      <div class="drawer-content">
        <add-credit-drawer
          v-if="addDrawer"
          :id="creditEvaluationId"
          :type="operateType"
          @close="handelCloseDrawer"
        ></add-credit-drawer>
        <company-credit-evaluation-detail
          v-if="!addDrawer"
          :id="creditEvaluationId"
          :credit-evaluation-detail="creditEvaluationDetail"
          @close="handleClose"
        ></company-credit-evaluation-detail>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import ESearch from '@/modules/projectA/components/common/e-search';
import ETableList from '@/modules/projectA/components/common/e-table-list';
import EDialog from '@/modules/projectA/components/common/e-dialog';
import Api from '@/modules/projectA/api/user/index';
import _, { get } from 'lodash';
import addCreditDrawer from './components/addCreditDrawer.vue';
import companyCreditEvaluationDetail from './components/companyCreditEvaluationDetail.vue';

export default {
  components: {
    ESearch,
    ETableList,
    EDialog,
    addCreditDrawer,
    companyCreditEvaluationDetail,
  },
  data() {
    return {
      operateType: '', // ADD:新增 EDIT:编辑
      addDrawer: false,
      drawerVisible: false,
      creditEvaluationId: null,
      options: {
        disabledDate(time) {
          const years = [2020, 2021, 2022];
          return years.includes(time.getFullYear());
        },
      },
      tableData: [],
      tableSelectData: [],
      pageTotal: 0,
      tableLabel: [
        {
          label: '序号',
          param: 'categoryName',
          align: 'center',
          fixed: 'left',
          slot: 'categoryName',
        },
        {
          label: '供应商编码',
          param: 'companyId',
          align: 'center',
          minWidth: '140',
        },
        {
          label: '供应商名称',
          param: 'companyName',
          align: 'center',
          minWidth: '140',
          tooltip: true,
        },
        {
          label: '单据状态',
          align: 'center',
          render: (row) => {
            return row.status === 1 ? '待提交' : '已提交';
          },
          minWidth: '140',
        },
        {
          label: '证书编号',
          param: 'certificateNo',
          align: 'center',
          minWidth: '160',
          tooltip: true,
        },
        {
          label: '评价等级',
          param: 'evaluationLevel',
          align: 'center',
          minWidth: '140',
        },
        {
          label: '有效期结束时间',
          param: 'certificateEffectiveEndTime',
          align: 'center',
          minWidth: '190',
        },
        {
          label: '财务数据年份',
          param: 'financeYear',
          align: 'center',
          minWidth: '170',
        },
        {
          label: '证书状态',
          param: 'certificateStatus',
          align: 'center',
          minWidth: '140',
          render: (row) => {
            return row.certificateStatus === 1 ? '过期' : '有效';
          },
        },
        {
          label: '更新时间',
          param: 'updateTime',
          align: 'center',
          minWidth: '170',
        },
        {
          label: '操作',
          align: 'center',
          width: '160',
          slot: 'operation',
          fixed: 'right',
        },
      ],
      queryData: {
        companyId: '',
        companyName: '',
        yearBegin: '',
        yearEnd: '',
        updateTimeBegin: '',
        updateTimeEnd: '',
        certificateStatus: '',
        status: '',
        pageNum: 1,
        pageSize: 10,
      },
      searchData: {
        companyId: '',
        companyName: '',
        financeYear: [],
        updateTime: [],
        status: '',
        certificateStatus: '',
      },
      cloneQueryData: {},
      fieldList: [
        {
          label: '供应商编码',
          type: 'input',
          value: 'companyId',
        },
        {
          label: '供应商名称',
          type: 'input',
          value: 'companyName',
        },
        {
          label: '证书状态',
          type: 'select',
          value: 'certificateStatus',
          list: 'certificateStatusList',
        },
        {
          label: '单据状态',
          type: 'select',
          value: 'status',
          list: 'statusList',
        },
        {
          label: '财务数据年份',
          type: 'date',
          value: 'financeYear',
          valueFormat: 'yyyy',
          dateType: 'monthrange',
        },
        {
          label: '更新时间',
          type: 'date',
          value: 'updateTime',
          defaultTime: ['00:00:00', '23:59:59'],
          valueFormat: 'yyyy-MM-dd',
          dateType: 'daterange',
        },
      ],
      listTypeInfo: {
        certificateStatusList: [
          {
            name: '有效',
            id: 2,
          },
          {
            name: '过期',
            id: 1,
          },
        ],
        statusList: [
          // {
          //   name: '全部',
          //   id: '',
          // },
          {
            name: '待提交',
            id: 1,
          },
          {
            name: '已提交',
            id: 2,
          },
        ],
      },
      creditEvaluationDetail: {},
    };
  },
  mounted() {
    this.cloneQueryData = _.cloneDeep(this.queryData);
    this.queryPurchaseDemandItemForPlan(this.queryData);
  },
  methods: {
    handleAdd(type, id) {
      this.drawerVisible = true;
      this.addDrawer = true;
      this.operateType = type;
      this.creditEvaluationId = String(id);
      console.log(this.operateType);
      console.log(this.creditEvaluationId);

      // if()
    },
    checkSelectable(row) {
      return row.status !== 2;
    },
    batchDel(type, id) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const list = [];
          if (type === 'mutil') {
            this.tableSelectData.forEach((item) => {
              list.push(item.creditEvaluationId);
            });
          }
          if (type === 'single') {
            list.push(id);
          }
          const res = await Api.deletedCompanyCreditEvaluation({
            creditEvaluationIdList: list,
          });
          if (res.code === '200') {
            this.$message({
              type: 'success',
              message: '删除成功!',
            });
            this.tableSelectData = [];
            this.$refs.multipleTable.handleClearSelection();
            this.queryData.pageNum = 1;
            this.queryPurchaseDemandItemForPlan(this.queryData);
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    },
    // 查询采购计划列表-分页查询
    async queryPurchaseDemandItemForPlan(params) {
      const res = await Api.queryCompanyCreditEvaluationPage(params);
      if (res.code === '200') {
        this.tableData = res.data?.records || [];
        this.pageTotal = res.data.total;
      }
    },

    // table批量选择
    handleSelectionChange(list) {
      console.log(list);
      this.tableSelectData = list;
    },

    // 查询
    handleFilter(val) {
      console.log(val);
      // this.queryData = val;
      //  this.queryData = val;
      this.queryData.companyId = val.companyId;
      this.queryData.companyName = val.companyName;
      this.queryData.status = val.status;
      this.queryData.certificateStatus = val.certificateStatus;
      const [yearBegin, yearEnd] = val.financeYear;
      const [updateTimeBegin, updateTimeEnd] = val.updateTime;
      this.queryData.pageNum = 1;
      this.queryData.yearBegin = yearBegin || '';
      this.queryData.yearEnd = yearEnd || '';
      this.queryData.updateTimeBegin = updateTimeBegin || '';
      this.queryData.updateTimeEnd = updateTimeEnd || '';
      this.queryPurchaseDemandItemForPlan(this.queryData);
    },
    // 重置
    handleReset() {
      this.queryData = { ...this.cloneQueryData };
      console.log(this.cloneQueryData);
      this.queryPurchaseDemandItemForPlan(this.queryData);
    },
    // 分页
    handleCurrentChange(val) {
      this.queryData.pageNum = val;
      this.queryPurchaseDemandItemForPlan(this.queryData);
    },
    handleSizeChange(val) {
      this.queryData.pageNum = 1;
      this.queryData.pageSize = val;
      this.queryPurchaseDemandItemForPlan(this.queryData);
    },
    async goToDetail(id) {
      this.creditEvaluationId = id;
      await this.getCreditEvaluationDetail();
      this.drawerVisible = true;
      this.addDrawer = false;
    },
    // 获取企业评价详情
    async getCreditEvaluationDetail() {
      const res = await Api.queryCompanyCreditEvaluationDetail({
        creditEvaluationId: this.creditEvaluationId,
      });

      if (res.code === '200') {
        this.creditEvaluationDetail = res.data;
      }
    },
    // 组装回显数据结构
    // format,
    handleClose() {
      this.drawerVisible = false;
    },
    handelCloseDrawer() {
      this.queryPurchaseDemandItemForPlan(this.queryData);
      this.drawerVisible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.search-box {
  padding: 10px 20px 10px 36px;
  border: 1px solid #d9d9d9;
  box-sizing: border-box;
  margin-bottom: 20px;
}

::v-deep .el-table {
  th.el-table__cell > .cell {
    font-weight: normal;
    font-size: 14px;
  }
}
.btn-main-more {
  display: inline-block;
  margin-right: 10px;
  padding: 0 10px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  font-size: 14px;
  color: #fff;
  background: #2587ff;
  -webkit-user-select: none;
  border-radius: 0px;
  cursor: pointer;
  &:hover {
    background: #126edf;
  }
}
.pagination-box {
  text-align: right;
}
.drawer-content {
  padding: 20px;
  height: 98vh;
  overflow: auto;
}
::v-deep .el-drawer__header {
  margin-bottom: 0;
  padding: 0 20px;
  height: 40px;
  display: flex;
  background: #f5f5f5;
  color: #333;
  flex-shrink: 0;
}
</style>
